
import { Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { ModelSizeModel } from '@models/model-size';
import { VariantColorModel } from '@models/variant-color';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ComponentCodeConstants } from '../../../../shared/component-constants';
import { BridgeDesignComponent } from '../bridge-design/bridge-design';
import { BridgeSizeComponent } from '../bridgesize/bridgesize';
import { ClipLengthComponent } from '../clip-length/clip-length';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    styleUrls: ['./_bridge-design-size-clip-length.scss'],
    template: `
        <div class="flex flex-1 flex-column bridge-container">
            <bridge-size
                class="bridge-size"
                [configuration]="configuration"
                [modelGroup]="modelGroup"
                [model]="model"
                [modelSize]="modelSize"
                [variants]="variants"
                [menu]="menu"
                [state]="state"
                [currentVariantConstant]="ComponentCodeConstants.Bridge"
                (setImageSliderByNameChange)="onSetImageSliderByName($event)"
                (updateSizeChange)="onUpdateSizeChange($event)"
                (updateVariantChange)="onUpdateVariantChange($event)"
                (updateComponentSizeChange)="onUpdateComponentSizeChange($event)"
                (updateVariantDesignChange)="onUpdateVariantDesignChange($event)"
            ></bridge-size>
            <bridge-design
                class="bridge-design"
                [configuration]="configuration"
                [modelGroup]="modelGroup"
                [model]="model"
                [modelSize]="modelSize"
                [variants]="variants"
                [menu]="menu"
                [state]="state"
                [currentVariantConstant]="ComponentCodeConstants.Bridge"
                (setImageSliderByNameChange)="onSetImageSliderByName($event)"
                (updateSizeChange)="onUpdateSizeChange($event)"
                (updateVariantChange)="onUpdateVariantChange($event)"
                (updateComponentSizeChange)="onUpdateComponentSizeChange($event)"
                (updateVariantDesignChange)="onUpdateVariantDesignChange($event)"
                (matchColorsChange)="onMatchColors(null)"
            ></bridge-design>
            <clip-length
                class="clip-length"
                [configuration]="configuration"
                [modelGroup]="modelGroup"
                [model]="model"
                [state]="state"
                [modelSize]="modelSize"
                [variants]="variants"
                [menu]="menu"
                [currentVariantConstant]="ComponentCodeConstants.BridgeClip"
                (onSetImageSliderByNameChange)="onSetImageSliderByName($event)"
                (updateSizeChange)="onUpdateSizeChange($event)"
                (updateVariantChange)="onUpdateVariantChange($event)"
                (updateComponentSizeChange)="onUpdateComponentSizeChange($event)"
                (updateVariantDesignChange)="onUpdateVariantDesignChange($event)"
            ></clip-length>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ClipLengthComponent, BridgeDesignComponent, BridgeSizeComponent]
})
export class BridgeDesignSizeClipLengthComponent extends BaseCustomizerComponent {
	public ComponentCodeConstants = ComponentCodeConstants;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	initData() {
	}

	onChanges(changes: SimpleChanges): void {
	}

	onSetImageSliderByName(e: string | Event) {
		this.setImageSliderByName(e as string);
	}

	onUpdateSizeChange(e: ModelSizeModel) {
		this.updateSize(e);
	}

	onUpdateVariantChange(e: ComponentVariantChangeModel) {
		this.updateVariant(e);
	}

	onUpdateComponentSizeChange(e: ComponentVariantChangeModel) {
		this.updateComponentSize(e);
	}

	onUpdateVariantDesignChange(e: ComponentVariantChangeModel) {
		this.updateVariantDesign(e);
	}

	onMatchColors(e: VariantColorModel | null) {
		this.matchColors(e);
	}
}
